/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "DecisionMethod": {
                    "values": {
                      "MOBILE_REDIRECT": 1,
                      "CASH_QR_CODE_SCAN": 2,
                      "NATIVE_QR_CODE_SCAN": 3,
                      "QR_CODE_PRESENT": 4,
                      "INTERNAL_API": 5,
                      "WEB_CHECKOUT": 6,
                      "NATIVE_MOBILE_CASH_APP": 7,
                      "ANDROID_ACTIVITY": 8,
                      "WEB_LOGIN": 9
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.DecisionMethod) {
  $root.addJSON(jsonData);
}

/**
 * Describes how a grant flow was triggered and / or decided.
 *
 * SOURCE DecisionMethod @ squareup/cash/grantly/api/decision_method.proto at 9:1
 */
export const DecisionMethod = $root.lookupEnum('squareup.cash.grantly.api.DecisionMethod').values;